<div class="card notes-docs-card">
  <div class="card-head notes-card-head">
    <div class="notes-title-block">
      <span class="material-icons notes-icon">description</span>
      <h2>Hospital Notes &amp; Documents</h2>
    </div>
    <button type="button" class="btn-add-note" *ngIf="!isReadOnly" (click)="openNoteModal()">
      <span class="material-icons">add</span>
      Add Note
    </button>
  </div>

  <div class="notes-card-body">
    <div class="notes-loading" *ngIf="notesLoading">
      <span class="material-icons spinning">sync</span>
      Loading notes…
    </div>

    <div class="notes-empty" *ngIf="!notesLoading && !hospitalNotes.length">
      <span class="material-icons notes-empty-icon">note_alt</span>
      <p>No notes added yet</p>
      <button type="button" class="btn-add-note-ghost" *ngIf="!isReadOnly" (click)="openNoteModal()">
        <span class="material-icons">add</span> Add your first note
      </button>
    </div>

    <div class="notes-list-scroll" *ngIf="!notesLoading && hospitalNotes.length">
      <table class="notes-table">
        <thead>
          <tr>
            <th class="col-note">Note</th>
            <th class="col-desc">Description</th>
            <th class="col-menu"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let note of hospitalNotes" class="note-row" (click)="openViewNoteModal(note)">
            <td class="note-name">
              <span class="note-dot"></span>
              {{ note.name }}
              <span class="visibility-badge" *ngIf="!isHM && showHmToggle" [ngClass]="note.isHMVisible ? 'visible' : 'hidden'">
                <span class="material-icons">{{ note.isHMVisible ? 'visibility' : 'lock' }}</span>
                {{ note.isHMVisible ? 'Visible to HM' : 'Internal only' }}
              </span>
            </td>
            <td class="note-desc" [title]="getNoteDescriptionPreview(note.description)">
              {{ getNoteDescriptionPreview(note.description) || '—' }}
            </td>
            <td class="note-menu-cell">
              <button
                type="button"
                class="note-menu-btn"
                *ngIf="canEditNote(note)"
                [matMenuTriggerFor]="noteMenu"
                [matMenuTriggerData]="{ note: note }"
                (click)="$event.stopPropagation()"
              >
                <span class="material-icons">more_vert</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<mat-menu #noteMenu="matMenu" class="note-action-menu">
  <ng-template matMenuContent let-note="note">
    <button mat-menu-item (click)="openNoteModal(note)">
      <mat-icon>edit</mat-icon>
      <span>Edit</span>
    </button>
    <button mat-menu-item class="delete-item" (click)="deleteNote(note)">
      <mat-icon>delete_outline</mat-icon>
      <span>Delete</span>
    </button>
  </ng-template>
</mat-menu>

<!-- View note dialog -->
<ng-template #viewNoteDialogTpl>
  <div class="note-dialog note-view-dialog">
    <div class="note-dialog-header">
      <div class="modal-title-block">
        <span class="material-icons modal-title-icon">description</span>
        <h3 class="modal-title">{{ viewingNote?.name }}</h3>
      </div>
      <button type="button" class="modal-close" (click)="closeViewNoteModal()">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="note-dialog-body note-view-body">
      <div
        class="note-view-content"
        *ngIf="viewingNote?.description"
        [innerHTML]="viewingNote.description"
      ></div>
      <p class="note-view-empty" *ngIf="!viewingNote?.description">No description provided.</p>
    </div>

    <div class="note-dialog-footer">
      <button type="button" class="btn-cancel" (click)="closeViewNoteModal()">Close</button>
      <button type="button" class="btn-teal" *ngIf="canEditNote(viewingNote)" (click)="editNoteFromView()">
        <span class="material-icons">edit</span>
        Edit Note
      </button>
    </div>
  </div>
</ng-template>

<!-- Note dialog template — opened via MatDialog -->
<ng-template #noteDialogTpl>
  <div class="note-dialog">
    <div class="note-dialog-header">
      <div class="modal-title-block">
        <span class="material-icons modal-title-icon">{{ editingNote ? 'edit_note' : 'note_add' }}</span>
        <h3 class="modal-title">{{ editingNote ? 'Edit Note' : 'Create New Note' }}</h3>
      </div>
      <button type="button" class="modal-close" (click)="closeNoteModal()">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="note-dialog-body">
      <div class="form-group">
        <label class="form-label">Note Name <span class="required">*</span></label>
        <input
          type="text"
          class="form-input"
          [(ngModel)]="noteForm.name"
          placeholder="Enter note name"
          autocomplete="off"
        />
      </div>
      <div class="form-group">
        <label class="form-label">Description <span class="optional-badge">Optional</span></label>
        <div class="note-editor-wrap">
          <div class="editor">
            <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
            <ngx-editor
              [editor]="editor"
              [(ngModel)]="noteForm.description"
              [disabled]="false"
              [placeholder]="'Add a description or paste a link…'"
              style="height: 200px; border-top: 1px solid #ddd;"
            ></ngx-editor>
          </div>
        </div>
      </div>
      <div class="toggle-row" *ngIf="showHmToggle">
        <label class="switch">
          <input type="checkbox" [(ngModel)]="noteForm.isHMVisible" [disabled]="noteSaving" />
          <span class="slider"></span>
        </label>
        <div>
          <div class="t">Show on Hospital Manager Dashboard</div>
          <div class="s" *ngIf="!noteForm.isHMVisible">Default &mdash; hidden, RM/VP tracking only</div>
          <div class="s" *ngIf="noteForm.isHMVisible">Published &mdash; visible to HM</div>
        </div>
      </div>
    </div>

    <div class="note-dialog-footer">
      <button type="button" class="btn-cancel" (click)="closeNoteModal()" [disabled]="noteSaving">Cancel</button>
      <button
        type="button"
        class="btn-teal"
        (click)="saveNote()"
        [disabled]="!noteForm.name?.trim() || noteSaving"
      >
        <span class="note-btn-spinner" *ngIf="noteSaving"></span>
        {{ noteSaving ? 'Saving…' : (editingNote ? 'Update Note' : 'Save Note') }}
      </button>
    </div>
  </div>
</ng-template>
